module.exports = __webpack_public_path__ + "static/calefaccion-501d9c7af76c4454aa37c89b8210bbd4.jpg";